(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-product-orbit-scene"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOrbit(section) {
    if (!section || section.dataset.orbitReady === 'true') return;

    var rail = section.querySelector('[data-orbit-rail]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-card]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-dot]'));
    var scenes = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-scene]'));
    if (!rail || !cards.length) return;
    section.dataset.orbitReady = 'true';

    var scrollFrame = 0;
    var currentIndex = -1;
    function setActive(index) {
      if (index === currentIndex) return;
      currentIndex = index;
      scenes.forEach(function (scene,i) { scene.classList.toggle('is-active',i===index); });
      cards.forEach(function (card, i) { card.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    function activeFromScroll() {
      var railRect = rail.getBoundingClientRect();
      var center = railRect.left + railRect.width / 2;
      var closest = 0;
      var distance = Infinity;
      cards.forEach(function (card, index) {
        var rect = card.getBoundingClientRect();
        var delta = Math.abs((rect.left + rect.width / 2) - center);
        if (delta < distance) { distance = delta; closest = index; }
      });
      setActive(closest);
    }
    rail.addEventListener('scroll', function () {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(activeFromScroll);
    }, { passive: true });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        cards[index].scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          inline: 'center', block: 'nearest'
        });
        setActive(index);
      });
    });

    cards.forEach(function (card, index) {
      card.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 750px) and (hover: hover)').matches) setActive(index);
      });
      card.addEventListener('focusin', function () {
        if (window.matchMedia('(min-width: 750px)').matches) setActive(index);
      });
      var stage = card.querySelector('[data-orbit-stage]');
      var media = card.querySelector('[data-orbit-media]');
      if (!stage || !media || card.querySelector('model-viewer')) return;

      var pointerId = null;
      var startX = 0;
      var startY = 0;
      var originX = 0;
      var originY = 0;
      var endTimer = null;

      function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
      }
      function paint(rx, ry) {
        media.style.setProperty('--orbit-rx', rx.toFixed(2) + 'deg');
        media.style.setProperty('--orbit-ry', ry.toFixed(2) + 'deg');
        media.style.setProperty('--orbit-tx', (ry * .42).toFixed(2) + 'px');
        media.style.setProperty('--orbit-ty', (rx * -.3).toFixed(2) + 'px');
        media.style.setProperty('--orbit-scale', '1.055');
        media.style.setProperty('--orbit-shadow-x', (-ry * .9).toFixed(2) + 'px');
      }
      function paintFromPointer(event) {
        var rect = stage.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = clamp((event.clientX - rect.left) / rect.width - .5, -.5, .5);
        var y = clamp((event.clientY - rect.top) / rect.height - .5, -.5, .5);
        paint(y * -27, x * 46);
      }
      function reset() {
        stage.classList.remove('is-dragging');
        media.style.setProperty('--orbit-rx', '0deg');
        media.style.setProperty('--orbit-ry', '0deg');
        media.style.setProperty('--orbit-tx', '0px');
        media.style.setProperty('--orbit-ty', '0px');
        media.style.setProperty('--orbit-scale', '1');
        media.style.setProperty('--orbit-shadow-x', '0px');
      }
      function endPointer(event) {
        if (pointerId === null || (event && event.pointerId !== pointerId)) return;
        if (stage.hasPointerCapture && stage.hasPointerCapture(pointerId)) {
          stage.releasePointerCapture(pointerId);
        }
        pointerId = null;
        clearTimeout(endTimer);
        stage.classList.remove('is-dragging');
        // Keep the last tilt visible briefly; previously it reset on finger lift.
        endTimer = setTimeout(reset, 850);
      }

      stage.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (pointerId !== null) return;
        clearTimeout(endTimer);
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        originX = 0;
        originY = 0;
        stage.classList.add('is-dragging');
        try { stage.setPointerCapture(event.pointerId); } catch (error) {}
        if (event.pointerType === 'mouse') paintFromPointer(event);
      });

      stage.addEventListener('pointermove', function (event) {
        if (pointerId !== null) {
          if (event.pointerId !== pointerId) return;
          // Gesture-based tilt works on iPhone even when a drag starts at image center.
          var dx = event.clientX - startX;
          var dy = event.clientY - startY;
          paint(clamp(dy * -.32 + originX, -15, 15), clamp(dx * .44 + originY, -24, 24));
          return;
        }
        if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          clearTimeout(endTimer);
          stage.classList.add('is-dragging');
          paintFromPointer(event);
        }
      });

      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);
      stage.addEventListener('lostpointercapture', function () {
        if (pointerId !== null) {
          pointerId = null;
          clearTimeout(endTimer);
          stage.classList.remove('is-dragging');
          endTimer = setTimeout(reset, 850);
        }
      });
      stage.addEventListener('pointerleave', function (event) {
        if (pointerId === null && event.pointerType === 'mouse') {
          clearTimeout(endTimer);
          stage.classList.remove('is-dragging');
          endTimer = setTimeout(reset, 450);
        }
      });
    });
    setActive(0);
    section.addEventListener('shopify:block:select', function (event) {
      var selected = event.target.closest('[data-orbit-card]');
      var index = cards.indexOf(selected);
      if (index < 0) return;
      setActive(index);
      if (window.matchMedia('(max-width: 749px)').matches) {
        selected.scrollIntoView({behavior: 'smooth', inline: 'center', block: 'nearest'});
      }
    });
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-skeez-orbit-scene]')) initOrbit(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-skeez-orbit-scene]').forEach(initOrbit);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-product-orbit"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOrbit(section) {
    if (!section || section.dataset.orbitReady === 'true') return;

    var rail = section.querySelector('[data-orbit-rail]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-card]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-dot]'));
    if (!rail || !cards.length) return;
    section.dataset.orbitReady = 'true';

    var scrollFrame = 0;
    function setActive(index) {
      cards.forEach(function (card, i) { card.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    function activeFromScroll() {
      var railRect = rail.getBoundingClientRect();
      var center = railRect.left + railRect.width / 2;
      var closest = 0;
      var distance = Infinity;
      cards.forEach(function (card, index) {
        var rect = card.getBoundingClientRect();
        var delta = Math.abs((rect.left + rect.width / 2) - center);
        if (delta < distance) { distance = delta; closest = index; }
      });
      setActive(closest);
    }
    rail.addEventListener('scroll', function () {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(activeFromScroll);
    }, { passive: true });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        cards[index].scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          inline: 'center', block: 'nearest'
        });
        setActive(index);
      });
    });

    cards.forEach(function (card) {
      var stage = card.querySelector('[data-orbit-stage]');
      var media = card.querySelector('[data-orbit-media]');
      if (!stage || !media || card.querySelector('model-viewer')) return;

      var pointerId = null;
      var startX = 0;
      var startY = 0;
      var originX = 0;
      var originY = 0;
      var endTimer = null;

      function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
      }
      function paint(rx, ry) {
        media.style.setProperty('--orbit-rx', rx.toFixed(2) + 'deg');
        media.style.setProperty('--orbit-ry', ry.toFixed(2) + 'deg');
        media.style.setProperty('--orbit-tx', (ry * .42).toFixed(2) + 'px');
        media.style.setProperty('--orbit-ty', (rx * -.3).toFixed(2) + 'px');
        media.style.setProperty('--orbit-scale', '1.055');
        media.style.setProperty('--orbit-shadow-x', (-ry * .9).toFixed(2) + 'px');
      }
      function paintFromPointer(event) {
        var rect = stage.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = clamp((event.clientX - rect.left) / rect.width - .5, -.5, .5);
        var y = clamp((event.clientY - rect.top) / rect.height - .5, -.5, .5);
        paint(y * -27, x * 46);
      }
      function reset() {
        stage.classList.remove('is-dragging');
        media.style.setProperty('--orbit-rx', '0deg');
        media.style.setProperty('--orbit-ry', '0deg');
        media.style.setProperty('--orbit-tx', '0px');
        media.style.setProperty('--orbit-ty', '0px');
        media.style.setProperty('--orbit-scale', '1');
        media.style.setProperty('--orbit-shadow-x', '0px');
      }
      function endPointer(event) {
        if (pointerId === null || (event && event.pointerId !== pointerId)) return;
        if (stage.hasPointerCapture && stage.hasPointerCapture(pointerId)) {
          stage.releasePointerCapture(pointerId);
        }
        pointerId = null;
        clearTimeout(endTimer);
        stage.classList.remove('is-dragging');
        // Keep the last tilt visible briefly; previously it reset on finger lift.
        endTimer = setTimeout(reset, 850);
      }

      stage.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (pointerId !== null) return;
        clearTimeout(endTimer);
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        originX = 0;
        originY = 0;
        stage.classList.add('is-dragging');
        try { stage.setPointerCapture(event.pointerId); } catch (error) {}
        if (event.pointerType === 'mouse') paintFromPointer(event);
      });

      stage.addEventListener('pointermove', function (event) {
        if (pointerId !== null) {
          if (event.pointerId !== pointerId) return;
          // Gesture-based tilt works on iPhone even when a drag starts at image center.
          var dx = event.clientX - startX;
          var dy = event.clientY - startY;
          paint(clamp(dy * -.32 + originX, -15, 15), clamp(dx * .44 + originY, -24, 24));
          return;
        }
        if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          clearTimeout(endTimer);
          stage.classList.add('is-dragging');
          paintFromPointer(event);
        }
      });

      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);
      stage.addEventListener('lostpointercapture', function () {
        if (pointerId !== null) {
          pointerId = null;
          clearTimeout(endTimer);
          stage.classList.remove('is-dragging');
          endTimer = setTimeout(reset, 850);
        }
      });
      stage.addEventListener('pointerleave', function (event) {
        if (pointerId === null && event.pointerType === 'mouse') {
          clearTimeout(endTimer);
          stage.classList.remove('is-dragging');
          endTimer = setTimeout(reset, 450);
        }
      });
    });
    activeFromScroll();
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-skeez-orbit]')) initOrbit(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-skeez-orbit]').forEach(initOrbit);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-scratch-discount"]) return;
  try {
    
(function(){
  var roots=document.querySelectorAll("[data-skz-scratch]");
  roots.forEach(function(root){
    if(root.dataset.ready==="1")return;
    root.dataset.ready="1";

    var launcher=root.querySelector("[data-launch]");
    var dialog=root.querySelector("[data-dialog]");
    var card=root.querySelector("[data-card]");
    var canvas=root.querySelector("[data-canvas]");
    var stages=root.querySelectorAll("[data-stage]");
    var prizeNodes=root.querySelectorAll("[data-prize]");
    var rewardTitle=root.querySelector("[data-reward-title]");
    var codeNode=root.querySelector("[data-code]");
    var emailWrap=root.querySelector("[data-email-wrap]");
    var claimActions=root.querySelector("[data-claim-actions]");
    var emailToggle=root.querySelector("[data-email-toggle]");
    var emailBack=root.querySelector("[data-email-back]");
    var emailForm=root.querySelector("[data-email-wrap] form");
    var emailStatus=root.querySelector("[data-email-status]");
    var whatsapp=root.querySelector("[data-whatsapp]");
    var copy=root.querySelector("[data-copy]");
    var apply=root.querySelector("[data-apply]");
    var timerNode=root.querySelector("[data-timer]");
    var timerLabel=root.querySelector("[data-timer-label]");
    var timerWrap=root.querySelector("[data-timer-wrap]");
    var timerInterval=null;
    var timerMinutes=Math.max(1,Number(root.dataset.timerMinutes||15));
    var campaign=root.dataset.campaign||"launch";
    var key="skeez-scratch-v5:"+campaign;
    var state={};
    var oldHtmlOverflow="";
    var oldBodyOverflow="";
    var ctx;
    var active=false;
    var lastPoint=null;
    var revealed=false;
    var moveChecks=0;

    try{state=JSON.parse(localStorage.getItem(key)||"{}")}catch(e){}

    function save(){try{localStorage.setItem(key,JSON.stringify(state))}catch(e){}}

    var prizes=[
      {label:"5% OFF",code:root.dataset.code5||"SKEEZ5",weight:Number(root.dataset.weight5||0)},
      {label:"10% OFF",code:root.dataset.code10||"SKEEZ10",weight:Number(root.dataset.weight10||0)},
      {label:"15% OFF",code:root.dataset.code15||"SKEEZ15",weight:Number(root.dataset.weight15||0)},
      {label:"FREE SHIPPING",code:root.dataset.codeship||"SKEEZSHIP",weight:Number(root.dataset.weightship||0)}
    ];

    function pick(){
      var existing=prizes.find(function(p){return p.code===state.prizeCode});
      if(existing)return existing;
      var total=prizes.reduce(function(n,p){return n+p.weight},0);
      var r=Math.random()*(total||1);
      var selected=prizes[0];
      prizes.some(function(p){r-=p.weight;if(r<=0){selected=p;return true}return false});
      state.prizeCode=selected.code;state.prizeLabel=selected.label;save();
      return selected;
    }

    var prize=pick();

    function paintPrize(){
      prizeNodes.forEach(function(n){n.textContent=prize.label});
      rewardTitle.textContent=prize.label;
      codeNode.textContent=prize.code;
    }

    function stopTimer(){
      if(timerInterval){clearInterval(timerInterval);timerInterval=null}
    }

    function updateTimer(){
      if(!state.claimedAt||!timerNode||!timerWrap)return;
      var duration=timerMinutes*60*1000;
      var remaining=Math.max(0,duration-(Date.now()-Number(state.claimedAt)));
      var totalSeconds=Math.ceil(remaining/1000);
      var mins=Math.floor(totalSeconds/60);
      var secs=totalSeconds%60;
      timerNode.textContent=String(mins).padStart(2,"0")+":"+String(secs).padStart(2,"0");

      if(remaining<=0){
        stopTimer();
        root.classList.add("skz-expired");
        if(timerLabel)timerLabel.textContent="OFFER WINDOW ENDED";
        if(apply)apply.disabled=true;
        if(copy)copy.disabled=true;
      }else{
        root.classList.remove("skz-expired");
        if(timerLabel)timerLabel.textContent="USE YOUR CODE WITHIN";
        if(apply)apply.disabled=false;
        if(copy)copy.disabled=false;
      }
    }

    function startTimer(){
      stopTimer();
      updateTimer();
      if(state.claimedAt && (Date.now()-Number(state.claimedAt)) < timerMinutes*60*1000){
        timerInterval=setInterval(updateTimer,1000);
      }
    }

    function setStage(name,instant){
      var next=root.querySelector('[data-stage="'+name+'"]');
      var current=root.querySelector(".skz-stage:not([hidden])");
      if(!next||current===next)return;

      if(instant||!current){
        stages.forEach(function(s){
          s.hidden=s!==next;
          s.classList.remove("skz-stage-in","skz-stage-out");
        });
        if(name==="reward")startTimer();
        return;
      }

      next.hidden=false;
      next.classList.remove("skz-stage-out");
      next.classList.add("skz-stage-in");
      current.classList.remove("skz-stage-in");
      current.classList.add("skz-stage-out");

      setTimeout(function(){
        current.hidden=true;
        current.classList.remove("skz-stage-out");
        next.classList.remove("skz-stage-in");
        if(name==="reward")startTimer();
      },500);
    }

    function lockPage(){
      oldHtmlOverflow=document.documentElement.style.overflow;
      oldBodyOverflow=document.body.style.overflow;
      document.documentElement.style.overflow="hidden";
      document.body.style.overflow="hidden";
    }

    function unlockPage(){
      document.documentElement.style.overflow=oldHtmlOverflow;
      document.body.style.overflow=oldBodyOverflow;
    }

    function show(){
      paintPrize();
      revealed=Boolean(state.revealedAt);
      card.classList.toggle("is-revealed",revealed);

      if(state.claimedAt)setStage("reward",true);
      else if(state.revealedAt)setStage("claim",true);
      else setStage("scratch",true);

      if(!dialog.open){
        lockPage();
        dialog.showModal();
      }

      if(!state.revealedAt)requestAnimationFrame(drawIce);
    }

    function close(){
      stopTimer();
      dialog.close();
      unlockPage();
    }

    launcher.addEventListener("click",show);

    var scratchParam=new URLSearchParams(location.search).get("skeez_scratch");
    if(scratchParam==="reset"){
      try{localStorage.removeItem(key)}catch(e){}
      state={};
      prize=pick();
      revealed=false;
      card.classList.remove("is-revealed");
      setStage("scratch",true);
      show();
    }else if(scratchParam==="1"){
      show();
    }

    root.querySelectorAll("[data-close]").forEach(function(b){b.addEventListener("click",close)});
    dialog.addEventListener("cancel",function(e){e.preventDefault();close()});
    dialog.addEventListener("close",unlockPage);

    function drawIce(){
      var rect=card.getBoundingClientRect();
      var dpr=Math.min(devicePixelRatio||1,2);
      canvas.width=Math.round(rect.width*dpr);
      canvas.height=Math.round(rect.height*dpr);
      ctx=canvas.getContext("2d",{willReadFrequently:true});

      var w=canvas.width;
      var h=canvas.height;
      var source=canvas.dataset.scratchImage;
      var img=new Image();
      img.crossOrigin="anonymous";

      function fallback(){
        var base=ctx.createLinearGradient(0,0,w,h);
        base.addColorStop(0,"#9fb7c4");
        base.addColorStop(.18,"#e8f0f4");
        base.addColorStop(.52,"#c7d7df");
        base.addColorStop(1,"#8fa9b7");
        ctx.fillStyle=base;
        ctx.fillRect(0,0,w,h);
      }

      function drawCover(){
        ctx.clearRect(0,0,w,h);
        ctx.drawImage(img,0,0,w,h);
      }

      img.onload=drawCover;
      img.onerror=fallback;
      img.src=source;
      if(img.complete&&img.naturalWidth){
        drawCover();
      }else{
        fallback();
      }
    }

    function point(e){
      var r=canvas.getBoundingClientRect();
      return{x:(e.clientX-r.left)*(canvas.width/r.width),y:(e.clientY-r.top)*(canvas.height/r.height)};
    }

    function scratch(p){
      if(!ctx||revealed)return;
      ctx.globalCompositeOperation="destination-out";
      ctx.lineCap="round";
      ctx.lineJoin="round";
      ctx.lineWidth=54*Math.min(devicePixelRatio||1,2);
      ctx.beginPath();
      if(lastPoint){ctx.moveTo(lastPoint.x,lastPoint.y);ctx.lineTo(p.x,p.y)}
      else{ctx.moveTo(p.x,p.y);ctx.lineTo(p.x+.1,p.y+.1)}
      ctx.stroke();
      lastPoint=p;
    }

    function percent(){
      if(!ctx)return 0;
      var data=ctx.getImageData(0,0,canvas.width,canvas.height).data;
      var clear=0,total=0;
      for(var i=3;i<data.length;i+=256){total++;if(data[i]<48)clear++}
      return total?clear/total*100:0;
    }

    function reveal(){
      if(revealed||state.revealedAt)return;
      revealed=true;active=false;
      card.classList.add("is-revealed");
      state.revealedAt=Date.now();save();
      setTimeout(function(){setStage("claim",false)},1000);
    }

    canvas.addEventListener("pointerdown",function(e){
      if(revealed)return;
      active=true;lastPoint=null;canvas.setPointerCapture(e.pointerId);scratch(point(e));e.preventDefault();
    });

    canvas.addEventListener("pointermove",function(e){
      if(!active||revealed)return;
      scratch(point(e));moveChecks++;
      if(moveChecks%7===0&&percent()>=Number(root.dataset.threshold||60))reveal();
      e.preventDefault();
    });

    function end(e){
      if(!active)return;
      active=false;lastPoint=null;
      if(canvas.hasPointerCapture(e.pointerId))canvas.releasePointerCapture(e.pointerId);
      if(!revealed&&percent()>=Number(root.dataset.threshold||60))reveal();
    }

    canvas.addEventListener("pointerup",end);
    canvas.addEventListener("pointercancel",end);
    card.addEventListener("keydown",function(e){if(e.key==="Enter"||e.key===" "){e.preventDefault();reveal()}});
    root.querySelector("[data-reveal]").addEventListener("click",reveal);

    function unlock(method){
      if(!state.claimedAt)state.claimedAt=Date.now();
      state.claimMethod=method;
      save();
      setStage("reward",false);
    }

    if(emailToggle&&emailWrap&&claimActions){
      emailToggle.addEventListener("click",function(){
        claimActions.hidden=true;
        emailWrap.hidden=false;
        var input=emailWrap.querySelector('input[type="email"]');
        if(input)setTimeout(function(){input.focus()},80);
      });
    }

    if(emailBack&&emailWrap&&claimActions){
      emailBack.addEventListener("click",function(){
        emailWrap.hidden=true;
        claimActions.hidden=false;
      });
    }

    async function submitEmailInline(){
      if(!emailForm)return;
      var button=emailForm.querySelector('button[type="submit"]');
      if(button&&button.disabled)return;
      if(button)button.disabled=true;
      if(emailStatus)emailStatus.textContent="Unlocking your reward…";

      try{
        var response=await fetch(emailForm.action,{
          method:"POST",
          body:new FormData(emailForm),
          credentials:"same-origin",
          redirect:"follow",
          headers:{"X-Requested-With":"XMLHttpRequest"}
        });
        if(!response.ok)throw new Error("subscribe failed");
        if(emailStatus)emailStatus.textContent="";
        unlock("email");
      }catch(err){
        if(emailStatus)emailStatus.textContent="We could not save that email. Please try again.";
        if(button)button.disabled=false;
      }
    }

    if(emailForm){
      root.addEventListener("submit",function(e){
        if(e.target!==emailForm)return;
        e.preventDefault();
        e.stopPropagation();
        if(typeof e.stopImmediatePropagation==="function")e.stopImmediatePropagation();
        submitEmailInline();
      },true);
    }

    if(whatsapp){
      whatsapp.addEventListener("click",function(e){
        if(whatsapp.getAttribute("aria-disabled")==="true"){e.preventDefault();return}
        unlock("whatsapp");
      });
    }

    copy.addEventListener("click",async function(){
      try{
        await navigator.clipboard.writeText(prize.code);
        copy.textContent="COPIED";
        setTimeout(function(){copy.textContent="COPY CODE"},1600);
      }catch(e){
        var range=document.createRange();range.selectNodeContents(codeNode);
        var sel=getSelection();sel.removeAllRanges();sel.addRange(range);
      }
    });

    apply.addEventListener("click",function(){
      location.assign("/discount/"+encodeURIComponent(prize.code)+"?redirect="+encodeURIComponent("/collections/all"));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-thermal-reveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (!section || section.dataset.thermalInitialized === 'true') return;
    section.dataset.thermalInitialized = 'true';

    var stage = section.querySelector('[data-thermal-stage]');
    var toggle = section.querySelector('[data-thermal-toggle]');
    var status = section.querySelector('[data-thermal-status]');
    if (!stage || section.dataset.imagesReady !== 'true' || !toggle) return;

    var delay = parseInt(getComputedStyle(section).getPropertyValue('--st-reset'), 10) || 450;
    var releaseTimer = null;
    var touching = false;

    function point(clientX, clientY) {
      var rect = stage.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = Math.max(0, Math.min(100, (clientX - rect.left) / rect.width * 100));
      var y = Math.max(0, Math.min(100, (clientY - rect.top) / rect.height * 100));
      stage.style.setProperty('--st-x', x.toFixed(2) + '%');
      stage.style.setProperty('--st-y', y.toFixed(2) + '%');
    }

    function reveal(event) {
      if (stage.classList.contains('is-full')) return;
      clearTimeout(releaseTimer);
      point(event.clientX, event.clientY);
      stage.classList.add('is-revealing');
      if (status) status.textContent = 'HEAT / REVEAL';
    }

    function reset() {
      if (!stage.classList.contains('is-full')) {
        stage.classList.remove('is-revealing');
        if (status) status.textContent = 'COLD / UNHEATED';
      }
    }

    function release() {
      touching = false;
      clearTimeout(releaseTimer);
      releaseTimer = setTimeout(reset, delay);
    }

    stage.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'mouse' || event.pointerType === 'pen') reveal(event);
    });
    stage.addEventListener('pointermove', function (event) {
      if (event.pointerType === 'mouse' || event.pointerType === 'pen' || touching) reveal(event);
    });
    stage.addEventListener('pointerdown', function (event) {
      touching = true;
      reveal(event);
    });
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
    stage.addEventListener('pointerleave', function (event) {
      if (event.pointerType !== 'touch') release();
    });

    toggle.addEventListener('click', function () {
      var full = !stage.classList.contains('is-full');
      clearTimeout(releaseTimer);
      stage.classList.toggle('is-full', full);
      stage.classList.remove('is-revealing');
      toggle.setAttribute('aria-pressed', full ? 'true' : 'false');
      toggle.innerHTML = full ? 'VIEW UNHEATED <span aria-hidden="true">↗</span>' : 'VIEW HEATED <span aria-hidden="true">↗</span>';
      if (status) status.textContent = full ? 'HEAT / FULL REVEAL' : 'COLD / UNHEATED';
    });
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-skeez-thermal]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-skeez-thermal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
